export default __webpack_public_path__ + "static/media/FTA-2026.1b41ac8e.png";